import React, { useState, useContext, useEffect } from 'react';
import {
  Button,
  Icon,
  Panel,
  SnackbarContext,
  Toolbar,
} from '@fanadise/common-ui';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ArrowSmLeftIcon } from '@heroicons/react/solid';
import EditCollectionForm from 'components/collections/EditCollectionForm';

import { Collection } from '@fanadise/common-types';
import { Translate, useTranslation } from '@fanadise/common-logic';
import { collectionsApi } from '@fanadise/common-data-access';

const CollectionsRouteEdit: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const { translate } = useTranslation();
  const { addErrorAlert } = useContext(SnackbarContext)!;
  const [collection, setCollection] = useState<Collection>();

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        setCollection(await collectionsApi.fetchCollection(id));
      } catch (err: any) {
        addErrorAlert(err.message || translate('error:default'));
        navigate('/account/collections', { replace: true });
      }
    };

    fetchCategory();
  }, [id]);

  return (
    <>
      <Toolbar
        title={<Translate id="collections:edit:title" />}
        leading={
          <Link to="/account/collections">
            <Button
              tag="span"
              variant="icon"
              icon={<Icon icon={ArrowSmLeftIcon} size="lg" />}
            />
          </Link>
        }
        mb="8"
      />

      {collection && (
        <Panel>
          <EditCollectionForm
            collection={collection}
            onChange={setCollection}
          />
        </Panel>
      )}
    </>
  );
};

export default CollectionsRouteEdit;
